<template>
  <div>
    <table>
      <thead class="head">
        <tr>
          <th v-for="(item, index) in dynamicHeader" :key="index">
            {{ item.label }}
          </th>
        </tr>
      </thead>
      <tbody v-if="!collapse">
        <tr v-for="item in data" :key="item.id">
          <td v-for="(un, indexItem) in item" :key="indexItem">{{
            un || '-'
          }}</td>
          <td actions.length>
            <div class="actions">
              <b-button
                v-for="(action, i) in actions"
                :key="`a${i}`"
                :variant="action.variant"
                @click="action.func(item)"
              >
                <i :class="action.classButton"></i>
              </b-button>
            </div>
          </td>
        </tr>
      </tbody>
      <BodyTable
        v-else
        :actions="actions"
        :data="data"
        :header="header"
        :typetable="typetable"
        :route="route"
        :actionline="actionline"
        :setcolor="setcolor"
        :currency-symbol="currencySymbol"
        :currency="currency"
      />
    </table>
  </div>
</template>

<script>
import BodyTable from '@/src/components/BodyTable.vue'

export default {
  name: 'TableDefault',
  components: {
    BodyTable,
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    setcolor: {
      type: Boolean,
      default: false,
    },
    header: {
      type: Array,
      required: true,
      default: () => [],
    },
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
    collapse: {
      type: Boolean,
      required: false,
      default: false,
    },
    typetable: {
      type: String,
      required: false,
      default: '',
    },
    route: {
      type: String,
      required: false,
      default: '/saques-agrupados',
    },
    actionline: {
      type: Object,
      required: false,
      default: () => {},
    },
    currencySymbol: {
      type: String,
      default: "R$"
    },
    currency: {
      type: String,
      default: "BRL"
    },
  },
  computed:{
    dynamicHeader(){
      if(this.$route.name === "Listar Saques Agrupados"){
        let copyHeader = [...this.header];
        copyHeader.splice(11, 0, { "label": "Score", "search": { "value": "value", "order": "" } });
        return copyHeader
      }
      else return this.header;
    }
  },
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  // border-collapse: collapse;
  font-size: 14px;
  thead {
    font-weight: 600;
    tr {
      th {
        &:first-child {
          border-radius: 10px 0 0 0;
        }
        &:last-child {
          border-radius: 0 10px 0 0;
        }
      }
    }
  }

  tbody {
    tr {
      &:nth-child(even) {
        background-color: #fff;
      }
    }
  }

  thead,
  tbody {
    font-family: 'Nunito', sans-serif;
    font-size: 14px;
    font-style: normal;
    text-align: left;
  }
}

tbody tr td,
thead tr th {
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  padding: 0.85rem;
}

.center {
  text-align: center;
  cursor: pointer;

  img {
    max-width: 24px;
    width: 100%;
  }
}

.actions {
  gap: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
</style>
